import { Box, InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Text from "../ui/Text";

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    padding: "0", // Reset padding on root
    "& fieldset": {
      borderColor: "#D4D4D4",
    },
    "&:hover fieldset": {
      borderColor: "#40A9FF",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1890FF",
    },
    "&.MuiInputBase-multiline": {
      padding: "0", // Override multiline padding
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "6px 10px !important", // Single line input
  },
  "& .MuiInputBase-inputMultiline": {
    padding: "6px 10px !important", // Multiline input
  },
  "& .MuiFormHelperText-root": {
    marginLeft: "0px",
  },
});

const Input = ({ label, error, helperText, prefix, sx, ...props }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {label && <Text variant="paragraph3">{label}</Text>}
      <StyledTextField
        fullWidth
        variant="outlined"
        error={error}
        helperText={helperText}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          ...(prefix && {
            startAdornment: (
              <InputAdornment position="start">
                <Text
                  variant="paragraph"
                  sx={{ color: "#666", ml: "12px", mr: "0px !important" }}
                >
                  {prefix}
                </Text>
              </InputAdornment>
            ),
          }),
          ...props.InputProps,
        }}
        {...props}
        sx={{ fontSize: "14px", ...sx }}
      />
    </Box>
  );
};

export default Input;
